import { render, staticRenderFns } from "./DevisView.vue?vue&type=template&id=22a92285&"
import script from "./DevisView.vue?vue&type=script&lang=js&"
export * from "./DevisView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports